import { render, staticRenderFns } from "./CommonPlanExpand.vue?vue&type=template&id=b29fa8f2&scoped=true&"
import script from "./CommonPlanExpand.vue?vue&type=script&lang=js&"
export * from "./CommonPlanExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29fa8f2",
  null
  
)

export default component.exports